import { useState, useMemo } from 'react';

export function useSortableData(rows, accessors, defaultSort = null) {
  const [sortConfig, setSortConfig] = useState(defaultSort);

  const requestSort = (key) => {
    setSortConfig((prev) => {
      if (!prev || prev.key !== key) return { key, dir: 'asc' };
      if (prev.dir === 'asc') return { key, dir: 'desc' };
      return defaultSort;
    });
  };

  const sorted = useMemo(() => {
    const list = [...(rows || [])];
    if (sortConfig && accessors[sortConfig.key]) {
      const acc = accessors[sortConfig.key];
      list.sort((a, b) => {
        const va = acc(a), vb = acc(b);
        if (va < vb) return sortConfig.dir === 'asc' ? -1 : 1;
        if (va > vb) return sortConfig.dir === 'asc' ? 1 : -1;
        return 0;
      });
    }
    return list;
  }, [rows, sortConfig, accessors]);

  return { sorted, sortConfig, requestSort };
}
